<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/establish/fddetail',title:'返利管理'},{title:'返利发票数据明细'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">

      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <el-form-item label="签收日期" class="timeselect" prop="erdat">
              <el-date-picker
                  @change="timeSelect"
                  v-model="timeValue"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width:300px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="返利公司" prop="contractId">
              <brselect category="fl_contract_type_main" :v="q.contractId" v-model="q.contractId" :clearable="true"/>
            </el-form-item>
            <el-form-item label="销售订单号" prop="aupos">
              <el-input v-model="q.aupos" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="kunrgLike">
              <el-input v-model="q.kunrgLike" placeholder="请输入编码或名称"></el-input>
            </el-form-item>
            <el-form-item class="h-formBtnOut">
              <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
              <el-button @click="qingkong" class="h-btn h-formBtn"
                         style="background-color:white;color:black;border:1px solid #d1d1d1">重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>


      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table
            ref="ddtable"
            :data="tableData"
            stripe
            style="width: 100%"
        >
          <el-table-column
              prop="erdat"
              :show-overflow-tooltip="true"
              label="签收日期"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="kunrg"
              :show-overflow-tooltip="true"
              label="客户编码"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="kunrgT"
              :show-overflow-tooltip="true"
              label="客户名称"
              width="210"
          >
          </el-table-column>
          <el-table-column
              prop="lianqun"
              :show-overflow-tooltip="true"
              label="链群"
              width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.lianqun | dictname('rebate_chain_group') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="belongIndustry"
              :show-overflow-tooltip="true"
              label="产业"
              width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.belongIndustry | dictname('fl_belong_industry') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="aupos"
              :show-overflow-tooltip="true"
              label="销售订单号"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="wrbtr"
              :show-overflow-tooltip="true"
              label="订单金额（含税）"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="zp00"
              :show-overflow-tooltip="true"
              label="内销基准价"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="materialGroup3"
              :show-overflow-tooltip="true"
              label="是否计算销额"
              width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.materialGroup3=='X'">是</div>
              <div v-if="scope.row.materialGroup3=='F'">否</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="materialGroup4"
              :show-overflow-tooltip="true"
              label="是否计算基数"
              width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.materialGroup4=='X'">是</div>
              <div v-if="scope.row.materialGroup4=='F'">否</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="matnr"
              :show-overflow-tooltip="true"
              label="物料编码"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="maktx"
              :show-overflow-tooltip="true"
              label="物料描述"
              width="170"
          >
          </el-table-column>
          <el-table-column
              prop="fkimg"
              :show-overflow-tooltip="true"
              label="物料数量"
              width="100"
          >
          </el-table-column>
          <el-table-column
              prop="aubel"
              :show-overflow-tooltip="true"
              label="sap订单号"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="vbeln"
              :show-overflow-tooltip="true"
              label="发票号"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="fkartT"
              :show-overflow-tooltip="true"
              label="发票类型"
              width="120">
            <template slot-scope="scope">
              {{ scope.row.fkartT | dictname('fanli_fptype') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="vkorg"
              :show-overflow-tooltip="true"
              label="销售组织"
              width="120">
          </el-table-column>
        </el-table>

        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      nowdate: this.$util.riQi(new Date()),
      timeValue: [this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))],
      //查询属性
      q: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //表格
      multipleSelection: [],

      //table列表
      tableData: [],
    }
  },
  created() {
    this.timeSelect();
    this.query();
  },
  methods: {
    //检索时间
    timeSelect() {
      if (this.timeValue == null || this.timeValue == '') {
        this.q.startCdate = null;
        this.q.endCdate = null;
      } else {
        this.q.startCdate = this.timeValue[0];
        this.q.endCdate = this.timeValue[1];
      }
    },
    //重置
    qingkong() {
      this.timeValue = [this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))],
      this.q = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      }
    },
    query() {
      ss.fanli.flInvoiceInfoPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    //勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/demo/newEtBilling/downloadFlInvoiceExcel", this.q, "post");
    },
  }
}
</script>

<style scoped>

</style>
<style>
.el-date-editor .el-range-separator {
  width: 8%;
}
</style>
